<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import markdownit from 'markdown-it'
import headerPlugin from '@/plugins/markdown-it-header-white'
import Loading from '@sections/global/Loading.vue'

const md = markdownit()
md.use(headerPlugin)

const route = useRoute()
const loading = ref(false)
const activation = ref({})
const requestActivation = ref(null)
const slug = computed(() => route.params.slug)

function cancelActivation() {
	if (requestActivation.value) requestActivation.value.cancel()
}
function getActivation() {
	loading.value = true
	activation.value = {}
	cancelActivation()
	let axiosSource = axios.CancelToken.source()
	requestActivation.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/activation/${route.params.slug}`, {
			cancelToken: axiosSource.token,
		})
		.then((p) => {
			loading.value = false
			activation.value = p.data
		})
		.catch((e) => {})
}
getActivation()

watch(slug, async () => {
	getActivation()
})

const terms = computed(() => {
	return activation.value.terms ? md.render(activation.value.terms) : null
})
</script>

<template>
	<Loading v-if="loading" />
	<section class="bg-gradient-to-br from-white/10 via-black via-45% to-black py-5 md:py-16" v-else>
		<div class="container">
			<div class="flex flex-col gap-5 md:gap-10">
				<div class="flex items-center gap-5">
					<img class="w-14 md:w-28" src="https://cdn.fatalfury.club/preorder-platform/images/logos/ff-cotw.png" alt="Fatal Fury: City of the Wolves Logo" />
					<img class="w-14 md:w-28" src="https://cdn.fatalfury.club/preorder-platform/images/logos/snk-blue.svg" alt="SNK Logo" />
					<!-- <img class="w-14 md:w-28" src="https://cdn.fatalfury.club/preorder-platform/images/logos/the-ring.svg" alt="The Ring Logo" /> -->
				</div>
				<div>
					<div class="full-terms" v-html="terms"></div>
				</div>
			</div>
		</div>
	</section>
</template>
